import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-negative-payment',
  templateUrl: './confirm-negative-payment.component.html',
  styleUrls: ['./confirm-negative-payment.component.scss']
})
export class ConfirmNegativePaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
